module.exports = __webpack_public_path__ + "assets/images/8f2a99cd9373ee0622f27e94ea2aa501.png";